import { useContext } from 'react';
import { TableStoreContext } from '../../../stores/TableStoreContext';
import { NumberColumnCombinedProps, NumberColumnTypeEnum } from './types';

const usePresenter = (props: NumberColumnCombinedProps): NumberColumnCombinedProps => {
  const { index, type } = props;
  const tableStore = useContext(TableStoreContext);
  const rowState = tableStore.tableState[index || 0];

  const isValidIndex = (index !== undefined);
  const isSelected = isValidIndex && tableStore.selectedRow === index;
  const isHovered = isValidIndex && tableStore.hoveredRow === index;

  const getColumnType = (): NumberColumnTypeEnum | undefined => {
    if (
      isValidIndex &&
      rowState.isInvalid &&
      !(isSelected || isHovered)
    ) {
      return 'Disabled';
    } else if (isSelected) {
      return 'CellSelected';
    } else if (isHovered) {
      return 'CellHovered';
    }
    return type;
  };

  const openRowExpandedModal = (event?: React.MouseEvent<HTMLButtonElement>) => {
    event?.preventDefault();
    tableStore.setSelectedRow(index);
    tableStore.setHoveredRow(undefined);
    tableStore.toggleModal();
    tableStore.resetRowState(index || 0);
  };

  return {
    ...props,
    onMouseDown: openRowExpandedModal,
    // text: {
    //   value: String((index || 0) + 1),
    // },
    type: getColumnType(),
  };
};

export default usePresenter;
